import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "axios";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);

  const API_BASE =
    window.location.hostname === "localhost"
      ? "http://localhost:8000"
      : "https://unipay.apps4food.com";

  const txnid = params.get("txnid");

useEffect(() => {
  if (!txnid) return;

  api.get(`${API_BASE}/api/payments/verify/${txnid}`, {
    withCredentials: true
  }).finally(async () => {
    try {
      const res = await api.get(
        `${API_BASE}/api/payments/transaction/${txnid}`,
        { withCredentials: true }
      );
      setTransaction(res.data.transaction);
    } catch {
      setTransaction(null);
    } finally {
      setLoading(false);
    }
  });
}, [txnid]);

  if (loading) return <div>Loading...</div>;

  if (!transaction) {
    return (
      <div className="max-w-xl mx-auto mt-24 p-6 bg-white shadow rounded">
        <h1 className="text-2xl font-bold text-red-600">Payment Not Found</h1>
        <p className="mt-4">We could not find your payment.</p>
      </div>
    );
  }

  const redirectToDashboard = () => {
    if (transaction.projectId) {
      window.location.href = `/projects/${transaction.projectId}`;
    } else {
      window.location.href = `/dashboard`;
    }
  };

  return (
    <div className="max-w-xl mx-auto mt-24 p-6 bg-white shadow rounded">
      <h1 className="text-2xl font-bold text-green-600">
        Payment Processing
      </h1>

      <div className="mt-5 space-y-2">
        <p><strong>Payment Status:</strong> {transaction.status}</p>
        <p><strong>Amount:</strong> ₹{transaction.amount}</p>
        <p><strong>Order ID:</strong> {transaction.gatewayOrderId}</p>
        <p><strong>Payment ID:</strong> {transaction.gatewayPaymentId || "-"}</p>

        <p>
          <strong>Verified At:</strong>{" "}
          {transaction.verifiedAt
            ? new Date(transaction.verifiedAt).toLocaleString()
            : "Pending"}
        </p>
      </div>

      <button
        onClick={redirectToDashboard}
        className="mt-6 px-5 py-2 bg-blue-600 text-white rounded"
      >
        Go to Dashboard
      </button>
    </div>
  );
}
